"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArguments = void 0;
const get_type_1 = require("./get-type");
exports.isArguments = (value) => get_type_1.getType(value) === "[object Arguments]";
//# sourceMappingURL=is-arguments.js.map